import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class QuestionStateService {

	private answers = new Map<string, string>();
		private lastVisitedIndex: number | null = null; 

	setAnswer(questionId: string, option: string| null) {
		this.answers.set(questionId, option ?? '');
	}

	getAnswer(questionId: string) {
		return this.answers.get(questionId);
	}

	setLastVisitedIndex(index: number) {
		this.lastVisitedIndex = index;
	}

	getLastVisitedIndex(): number | null {
		return this.lastVisitedIndex;
	}
}